import * as React from "react";

function SvgAppcues(props, ref) {
  return (
    <svg height="1em" viewBox="0 0 64 64" width="1em" {...{ ...props, ref }}>
      <g fill="#5757f5">
        <path d="M28.8 34.9L46.7 63c.4.7 1.2 1 2 1h6.6c1.2 0 2.3-1 2.3-2.2V2.3c0-1.3-1-2.3-2.3-2.3-.7 0-1.3.3-1.8.9L28.8 32.2c-.5.8-.5 1.9 0 2.7zM8.7 64h11.8c1.2 0 2.3-1 2.3-2.2V46.6c0-1.3-1.1-2.3-2.3-2.3-.7 0-1.3.3-1.8.9L6.8 60.3c-.8 1-.5 2.5.5 3.2.4.3.9.5 1.4.5z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAppcues);
